export type AppEnvironment = 'staging' | 'development' | 'production'

export const getAppEnvironment = (): AppEnvironment => {
  // The order is important here, since AUTH_COOKIE_ENV
  // would otherwise take priority and display "staging" in dev
  if (process.env.NODE_ENV === 'development') {
    return 'development'
  }

  if (process.env.AUTH_COOKIE_ENV === 'staging') {
    return 'staging'
  }

  return 'production'
}
